import { select } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { LoggedUser } from '../core/logged/logged.model';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserGuard implements CanActivate {
  @select(['logged', 'logged'])
  loggedUser$: Observable<LoggedUser>;

  constructor(private router: Router) {}
  canActivate(): Observable<boolean> {
    return this.loggedUser$.pipe(
      first(),
      map((user) => !!user && !!user.token),
      tap(isLogged => {
        if (!isLogged) {
          console.error('Non sei autorizzato a visualizzare la pagina selezionata');
          this.router.navigate(['/home']);
        }
      })
    );
  }
}
